"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const UserRegistrationContext_1 = require("@/context/UserRegistrationContext");
const Shared_1 = require("@/components/styled-controls/Shared");
const constant_1 = require("@/constants/constant");
const useApiService_1 = require("@/api/useApiService");
const Layout_1 = __importDefault(require("@/components/organisms/Layout"));
const componentlibrary_1 = require("@emarketer/componentlibrary");
const TaxonomyCheckbox_1 = __importDefault(require("@/components/molecules/TaxonomyCheckbox"));
const code_helpers_1 = require("@emarketer/code-helpers");
const PushFormSuccessValuestoDataLayer_1 = require("@/helpers/PushFormSuccessValuestoDataLayer");
const Industry = () => {
    const { setStep, userData, setUserData, appProps } = (0, UserRegistrationContext_1.useUserRegistration)();
    const { preferenceApiUrl, analyticsPrefix, subscriptionApiUrl } = appProps;
    const registrationStepCopy = appProps.registrationStepCopy?.INDUSTRIES?.TITLE || constant_1.HEADER_TEXTS.INDUSTRIES.TITLE;
    const subHeaderText = appProps.registrationStepCopy?.INDUSTRIES?.SUBTITLE || constant_1.HEADER_TEXTS.INDUSTRIES.SUBTITLE;
    const [selectedIndustries, setSelectedIndustries] = (0, react_1.useState)(userData?.industries || []);
    const [validationError, setValidationError] = (0, react_1.useState)('');
    const [isButtonDisabled, setIsButtonDisabled] = (0, react_1.useState)(false);
    const handleIndustryChange = (industry) => {
        setSelectedIndustries((prevIndustries) => prevIndustries.includes(industry) ? prevIndustries.filter((i) => i !== industry) : [...prevIndustries, industry]);
    };
    const { userService, handleResponse } = (0, useApiService_1.useApiService)();
    /**
     * Handles the success response after submitting industries.
     * If the response contains a userId, updates the user data with the selected industries and proceeds to the next step.
     * Otherwise, sets a validation error indicating that something went wrong.
     */
    const industrySubmissionHandler = () => {
        setUserData((prevData) => ({ ...prevData, industries: selectedIndustries }));
    };
    /**
     * Handles the success response after submitting remainig steps.
     */
    const successHandler = () => {
        setIsButtonDisabled(false);
        (0, PushFormSuccessValuestoDataLayer_1.pushFormSuccessValuestoDataLayer)({
            // push values to DL only after successful submission
            'form-name': `${constant_1.AMPLITUDE_IDENTIFY_TAGS.FORM}-industry`,
            industries: selectedIndustries,
            email: userData.email,
            id: userData.id,
        });
        setStep('newsletter');
    };
    /**
     * Handles the next step after submitting industries.
     * Sends a request to the userService to submit the selected industries for the user.
     * If the request is successful, calls the successHandler function.
     * Otherwise, sets a validation error indicating that something went wrong.
     */
    const handleNext = async () => {
        setIsButtonDisabled(true);
        try {
            const userPreferences = selectedIndustries.map((industry) => {
                const taxonomyType = constant_1.INDUSTRIES.flat().find((item) => item.label === industry).taxonomyType;
                return { Type: taxonomyType, RootTaxonomy: industry };
            });
            const response = await userService.submitIndustries(`${preferenceApiUrl}/userpreferences`, userPreferences, userData.id);
            await handleResponse(response, industrySubmissionHandler, null);
            const remainingStepResponse = await userService.submitRemainingStepForOnBoarding(`${subscriptionApiUrl}/freemiumremainingsteps`, constant_1.FREEMIUM.REMAINING_STEPS.NEWSLETTERS, userData.email, userData.id);
            await handleResponse(remainingStepResponse, successHandler, null);
        }
        catch (error) {
            setValidationError(constant_1.SOMETHING_WENT_WRONG_ERROR);
            setIsButtonDisabled(false);
        }
    };
    const industries = constant_1.INDUSTRIES.map((group) => group.map(({ label, analyticsSuffix }) => ({
        label: label,
        analytics: constant_1.DATA_ANALYTICS_TAG.INDUSTRIES.INDUSTRY_SELECTION(analyticsPrefix, analyticsSuffix),
    })));
    const renderCheckboxColumn = (industries) => (react_1.default.createElement(Shared_1.CheckboxColumn, null, industries.map(({ label, analytics, type }) => (react_1.default.createElement(TaxonomyCheckbox_1.default, { key: label, label: label, value: label, onClick: handleIndustryChange, analytics: analytics, id: `${constant_1.AMPLITUDE_IDENTIFY_TAGS.CHECKBOX}-industry-${(0, code_helpers_1.removeSpacesAndNonAlphaNumeric)(label).toLowerCase()}`, name: `${constant_1.AMPLITUDE_IDENTIFY_TAGS.CHECKBOX}-industry-${(0, code_helpers_1.removeSpacesAndNonAlphaNumeric)(label).toLowerCase()}` })))));
    return (react_1.default.createElement(Layout_1.default, { registrationStepCopy: registrationStepCopy, subHeaderText: subHeaderText, errorText: validationError },
        react_1.default.createElement(Shared_1.IndustryBodyContainer, null,
            react_1.default.createElement(Shared_1.CheckboxContainer, null, industries.map(renderCheckboxColumn))),
        react_1.default.createElement(Shared_1.ButtonContainer, null,
            react_1.default.createElement(Shared_1.StyledButton, { forwardedAs: "button", buttonType: "custom", callback: () => {
                    setUserData((prevData) => ({ ...prevData, industries: selectedIndustries })); // make sure selected item is saved in context while going back
                    setStep('basicInfo');
                }, dataAnalytics: constant_1.DATA_ANALYTICS_TAG.INDUSTRIES.BACK(analyticsPrefix), size: "m", style: {
                    backgroundColor: `${componentlibrary_1.COLOR.II.WHITE}`,
                    color: `${componentlibrary_1.COLOR.II.BLACK}`,
                    border: `1px solid ${componentlibrary_1.COLOR.II.BLACK}`,
                }, "$isCustom": true, id: `${constant_1.AMPLITUDE_IDENTIFY_TAGS.BUTTON}-back-industry`, name: `${constant_1.AMPLITUDE_IDENTIFY_TAGS.BUTTON}-back-industry` }, "Back"),
            react_1.default.createElement(Shared_1.StyledButton, { forwardedAs: "button", buttonType: "default", callback: handleNext, dataAnalytics: constant_1.DATA_ANALYTICS_TAG.INDUSTRIES.NEXT(analyticsPrefix), size: "m", disabled: selectedIndustries.length === 0 || isButtonDisabled, "$isDisabled": selectedIndustries.length === 0 || isButtonDisabled, id: `${constant_1.AMPLITUDE_IDENTIFY_TAGS.BUTTON}-next-industry`, name: `${constant_1.AMPLITUDE_IDENTIFY_TAGS.BUTTON}-next-industry` }, "Next"))));
};
exports.default = Industry;
